/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import costHintBoxStyle from "./costHintBoxStyle";
import { Box, Typography } from "@mui/material";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";
import AlertLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertLegalbird";
import AlertContentLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertContentLegalbird";

type CostHintBoxProps = {
    settlement: AbstractCase;
}

const CostHintBox = ({ settlement }: CostHintBoxProps) => {
  return (
    <AlertLegalbird variant={"hint"} severity={"success"}>
      <AlertContentLegalbird
        title={"Die Prüfung der Kündigung ist kostenlos und völlig unverbindlich!"}
        subtitle={
          <>
            {settlement.legalExpenseInsurance && (
              <Box>Ihre Rechtsschutzversicherung trägt auch im Anschluss an die Prüfung alle Kosten. Wir übernehmen zudem den Selbstbehalt für Sie!</Box>
            )}
            {settlement.noWinNoFee && !settlement.legalExpenseInsurance && (
              <Box>Sie zahlen erst, wenn Sie durch uns Klage gegen die Kündigung einreichen möchten und auch dann nur bei Erfolg!</Box>
            )}
          </>
        }
      />
    </AlertLegalbird>
  );
};

export default CostHintBox;
